module.exports = __webpack_public_path__ + "static/img/4322_phase_function_Paper_PointsHejduk_Prediction.1df2925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4322_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VvtH
// module chunks = 0